import { ChangeDetectorRef, Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { AlertService } from 'app/mock-api/common/services/alert.service';
import { Subject, takeUntil } from 'rxjs';
import { ReportService } from '../../reports.service';
import { SaiDialogHeaderComponent } from 'app/ui/sai-dialog-header/sai-dialog-header.component';

@Component({
  selector: 'app-send-report',
  standalone: true,
  imports: [
        SaiDialogHeaderComponent,
    CommonModule,
    CdkScrollable,
    TranslocoModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './send-report.component.html',
  styleUrl: './send-report.component.scss'
})
export class SendReportComponent implements OnInit, OnDestroy {
  form: FormGroup;
  protected _unsubscribeAll = new Subject<void>();
  lang: string = 'en';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private _dialogRef: MatDialogRef<SendReportComponent>,
    private _dialog: MatDialog,
    private _alertService: AlertService,
    private _report:ReportService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _translocoService: TranslocoService) { }
  ngOnInit() {
    this._translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.lang = res;
      this._changeDetectorRef.markForCheck();
    })
    this.form = this._fb.group({
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.maxLength(400)]],
    });

  }

  save() {
    const modal = {
      receiver: this.form.get('email').value,
      message:this.form.get('message').value,
      reportId:this.data.id
    }
    this._report.sendEmail(modal).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this._alertService.successMessage('Report sent successfully!');
      this._dialogRef.close(true)
    },(error)=>{
      this._alertService.failedMessage(error.error.message)
    })
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }



}
